import { render, staticRenderFns } from "./GuestbookEntryPage.vue?vue&type=template&id=97f6d5ea&scoped=true"
import script from "./GuestbookEntryPage.vue?vue&type=script&lang=js"
export * from "./GuestbookEntryPage.vue?vue&type=script&lang=js"
import style0 from "./GuestbookEntryPage.vue?vue&type=style&index=0&id=97f6d5ea&prod&lang=scss&scoped=true"
import style1 from "./GuestbookEntryPage.vue?vue&type=style&index=1&id=97f6d5ea&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97f6d5ea",
  null
  
)

export default component.exports